module.exports  = [
    'dataContext', 
    'common',
    customsOfficeDataService
];

function customsOfficeDataService(
    dataContext, 
    common
) { 

    var service = {
        response: {
            Results: null,
        },
        data: {
            isLoading: false,
        },
        display: 'list',
        filter: {
            referenceNumber: null,
            usualName: null,
            country: null,
            region: null,
            city: null,
            roles: null,
            traffictypes: null,
            isOpenNow: false,
            isOpenByDay: null,
            pageNumber: 1,
        },
        Countries : [],
        Regions: [],
        selectedRegion: null,
        Cities: [],
        Roles: [],
        selectedRoleGroup: null,
        filteredRoles: [],
        RoleGroups: [], // Ye olde role groups
        roleGroups: null, // New role groups
        TrafficTypes: [],
        activeCustomsOffice: null,
        updateRoleGroups: updateRoleGroups,
        getSelectedRoles: getSelectedRoles,
        getUnselectedRoles: getUnselectedRoles,
        loadCountries : loadCountries,
        loadRoleGroups: loadRoleGroups,
        loadRoles : loadRoles,
        loadTrafficTypes: loadTrafficTypes,
        loadRegions: loadRegions,
        loadCities: loadCities,
        loadCustomsOffices: loadCustomsOffices,
        getCustomsOffice: getCustomsOffice,
        loadHolidays: loadHolidays,
    };

    return service;

    function loadCountries() {
        var url = common.config.apiHosts.generic + '/customs-offices/countries';
        return dataContext.get(url).then(countries => {
            service.Countries = _.map(countries, country => ({ code: country.CountryCode, name: country.CountryName }));
            return service.Countries;
        });
    }

    function getCustomsOffice(reference) {
        service.data.isLoading = true;
        var url = common.config.apiHosts.generic + '/customs-offices/search/'+reference; 
        return dataContext.get(url).then(customsoffice => {
            service.activeCustomsOffice = customsoffice;
            service.data.isLoading = false;
        });
    }

    function loadHolidays(country, region) {
        var url = common.config.apiHosts.generic + '/customs-offices/holidays?country=' + country;
        if(region) {
            url = url + '&countryregion='+ region;
        }
        return dataContext.get(url);
    }

    function loadRoleGroups() {
        var url = common.config.apiHosts.generic + '/customs-offices/role-groups';
        return dataContext.get(url)
            .then(roleGroups => { 
                service.roleGroups = roleGroups;
            });
    }

    function loadRoles() {
        var url = common.config.apiHosts.generic + '/customs-offices/roles';
        return dataContext.get(url).then(function (roles) {
            service.Roles = roles;
            service.RoleGroups = _.chain(roles)
                .map(role => role.RoleGroup)
                .uniq()
                .sort()
                .value();
        });
    }

    function loadTrafficTypes() {
        var url = common.config.apiHosts.generic + '/customs-offices/traffic-types';
        return dataContext.get(url).then(function (traffictypes) {
            service.TrafficTypes = traffictypes;
            return service.TrafficTypes;
        });
    }

    function loadRegions() {
        var url = common.config.apiHosts.generic + '/customs-offices/country-regions?' + 
            'country='+ service.filter.country;
        return dataContext.get(url).then(regions => {
            service.Regions = _.map(regions, region => ({ code: region.RegionCode, name: region.RegionName }));
            return service.Regions;
        });
    }

    function loadCities() {
        var url = common.config.apiHosts.generic + '/customs-offices/cities?' + 
            'country=' + service.filter.country;
        if(service.filter.region) {
            url = url + '&countryregion='+ service.filter.region;
        }
        return dataContext.get(url).then(function (cities) {
            service.Cities = cities;
            return service.Cities;
        });
    }

    function updateRoleGroups() {
        if (service.roleGroups) {
            service.roleGroups.forEach((roleGroup) => {
                roleGroup.isSelected = roleGroup.Roles.every(x => x.isSelected);
                roleGroup.selectedRoleCount = roleGroup.Roles.filter(x => x.isSelected).length;
            });
        }
    }
    function getSelectedRoles() {
        console.log('Updating selected roles');
        if (!service.roleGroups) {
            console.log('No role groups (yet)');
            return [];
        }
        return service.roleGroups
            .filter(grp => grp.selectedRoleCount > 0)
            .flatMap(grp => grp.Roles
                .filter(role => role.isSelected)
            );
    }

    function getUnselectedRoles() {
        console.log('Updating unselected roles');
        if (!service.roleGroups) {
            console.log('No role groups (yet)');
            return [];
        }
        return service.roleGroups
            .filter(grp => !grp.isSelected)
            .flatMap(grp => grp.Roles
                .filter(role => !role.isSelected)
            );
    }

    function loadCustomsOffices() {
        service.activeCustomsOffice = null;
        service.data.isLoading = true;
        var url = common.config.apiHosts.generic + '/customs-offices/search'; 
        var query = '?psize=10&pindex=' + (service.filter.pageNumber - 1);

        var roles = getSelectedRoles(service.roleGroups).map(role => role.Code).join();

        if(service.filter.referenceNumber) {
            query = query + '&customsofficenumber=' + service.filter.referenceNumber; 
        }
        else {
            if(service.filter.country) {
                query = query + '&country=' + service.filter.country;
            }
            if(service.filter.usualName) {
                query = query + '&customsofficename=' + service.filter.usualName;
            }
            if(service.filter.region) {
                query = query + '&countryregion='+ service.filter.region;
            }
            if(service.filter.city) {
                query = query + '&city='+ service.filter.city;
            }
            if(service.filter.isOpenNow) {
                query = query + '&isopennow=true';
            }
            if(roles) {
                query = query + '&customsofficeroles='+ roles;
            }
            if(service.filter.traffictypes) {
                query = query + '&traffictypes='+ service.filter.traffictypes;
            }
            if(service.filter.isOpenByDay) {
                query = query + '&openbyday='+ service.filter.isOpenByDay;
            }
        }
        return dataContext.get(url + query).then(function (customsoffices) {
            service.data.isLoading = false;
            service.response = customsoffices;
        });
    }
}